import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import SetTrackRow from "./SetTrackRow";

export default function SortableSetTrackRow({ setTrack, index, ...props }) {
  const id = setTrack.id;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <SetTrackRow
      setTrack={setTrack}
      index={index}
      attributes={attributes}
      listeners={listeners}
      setNodeRef={setNodeRef}
      transform={transform}
      transition={transition}
      isDragging={isDragging}
      {...props}
    />
  );
}
